import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';
import { CreateDialogViewTemplate } from '../create-dialog-template/create-dialog-view-template';

const vt = viewTexts.dialogs.createNewCompany;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  registererName: string;
  companyName: string | undefined;
  companyNameErrors: string[] | undefined;
  companyNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const CreateNewCompanyDialogView: FC<Props> = memo(
  ({
    open,
    onClose,
    registererName,
    companyName = '',
    companyNameErrors = [],
    companyNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => (
    <CreateDialogViewTemplate
      open={open}
      onClose={onClose}
      title={vt.title}
      descriptions={vt.descriptions}
      submitButtonEnabled={submitButtonEnabled}
      nonFieldErrors={nonFieldErrors}
    >
      <InputWrapper>
        <MuiInput
          label={vt.labels.registerer}
          required={true}
          value={registererName}
          disabled={true}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiInput
          label={vt.labels.companyName}
          required={true}
          value={companyName}
          onInput={companyNameOnInput}
          helperText={companyNameErrors.join(' ')}
          error={companyNameErrors.length > 0}
        />
      </InputWrapper>
    </CreateDialogViewTemplate>
  )
);

CreateNewCompanyDialogView.displayName = 'CreateNewCompanyDialogView';
